
<template lang="html">

  <div class="main-container">

    <section class="mobile">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <div class="masthead-logo-mobile mobile">
              <img :src="'static/img/common/logo.png'" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="about-section">
      <div class="container">
        <div class="row text-center">
          <div class="col-md-10 col-md-offset-1 text-center">
            <h1 class="h1-title" v-html="about.title"></h1>
            <h3 class="h3-subtitle h3-subtitle-padded" v-html="about.subtitle"></h3>
            <p class="page-paragraph" v-for="(p, index) in about.body" v-html="p"></p>
          </div>
        </div>
      </div>
    </section>

    <!-- CLIENTS  -->
    <section class="pure-text-centered" id="clients">
      <client-section></client-section>
    </section>

    <section>
      <contact-section></contact-section>
    </section>


    <section class="section-joined-bottom">
      <text-ticker page="home"></text-ticker>
    </section>

    <section class="section-joined-top">
      <footer-image></footer-image>
    </section>
    

  </div>

</template>

<style type="text/css">

</style>

<script>
import {about, clients} from '../../content.json'
// var dataURL = 'https://api.ralphandco.com/updates'
import MastHead from '../components/MastHead'
import {commontools} from '../mixins/Styling'
import LinkButton from '../components/LinkButton'
import FooterImage from '../components/FooterImage'
import TextTicker from '../components/TextTicker'
import ContactSection from '../components/ContactSection'
import ClientSection from '../components/ClientSection'

export default {
  mixins: [commontools],
  name: 'about',
  watch: {
    '$route.name': function (id) {
      window.scrollTo(0, 0)
    }
  },
  data () {
    return {
      about,
      clients
    }
  },
  methods: {
  },
  created: function () {

  },
  mounted: function () {
    window.scrollTo(0, 0)
    // setTimeout(() => {
    //   this.manageWidows()
    // }, 100)
  },
  components: {
    MastHead,
    LinkButton,
    FooterImage,
    TextTicker,
    ContactSection,
    ClientSection
  }
}
</script>


// WEBPACK FOOTER //
// About.vue?195c0dc2